(() => {
  'use strict';
  document.documentElement.classList.add('js');
  const root = (document.body.dataset.root || '/').replace(/\/?$/, '/');
  const route = path => root + path;
  const drawer = document.getElementById('CartDrawer');
  let previousFocus = null;
  let drawerBusy = false;
  let currency = 'USD';
  const count = cart => document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency}).format(Number(cents) / 100); }
    catch (_) { return `${(Number(cents) / 100).toFixed(2)} ${currency}`; }
  };
  async function jsonRequest(path, options = {}) {
    const response = await fetch(route(path), {credentials: 'same-origin', ...options, headers: {Accept: 'application/json', ...(options.headers || {})}});
    let data;
    try { data = await response.json(); }
    catch (_) { throw new Error('The store could not respond. Please try again or open your cart.'); }
    if (!response.ok) {
      const message = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'This request could not be completed. Please try again.';
      throw new Error(message);
    }
    return data;
  }
  function textElement(tag, content, className) {
    const el = document.createElement(tag); el.textContent = content;
    if (className) el.className = className;
    return el;
  }
  function renderCart(cart) {
    if (!drawer) return;
    currency = cart.currency || currency;
    count(cart);
    const content = drawer.querySelector('[data-cart-content]');
    content.replaceChildren();
    if (!cart.items.length) content.append(textElement('p', 'Your cart is empty. Choose your quantity and add it to your cart.'));
    cart.items.forEach(item => {
      const row = document.createElement('div'); row.className = 'drawer-item';
      const img = document.createElement('img');
      if (item.image) img.src = item.image;
      else img.src = document.querySelector('.sticky-product img')?.src || '';
      img.alt = item.product_title || item.title; img.width = 76; img.height = 90;
      const info = document.createElement('div');
      info.append(textElement('h3', item.product_title || item.title));
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(textElement('p', item.variant_title));
      if (item.selling_plan_allocation?.selling_plan?.name) info.append(textElement('p', item.selling_plan_allocation.selling_plan.name));
      info.append(textElement('p', `Quantity: ${item.quantity}`), textElement('p', money(item.final_line_price)));
      const remove = textElement('button', 'Remove'); remove.type = 'button';
      remove.setAttribute('aria-label', `Remove ${item.product_title || item.title}`);
      remove.addEventListener('click', async () => {
        if (drawerBusy) return;
        drawerBusy = true;
        drawer.querySelectorAll('.drawer-item button').forEach(el => {el.disabled = true;});
        const status = drawer.querySelector('[data-cart-status]'); status.textContent = '';
        try {renderCart(await jsonRequest('cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: item.key, quantity: 0})}));}
        catch (error) {status.textContent = error.message || 'Unable to update your cart. Please try again.';}
        finally {drawerBusy = false; drawer.querySelectorAll('.drawer-item button').forEach(el => {el.disabled = false;});}
      });
      info.append(remove);row.append(img, info);content.append(row);
    });
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    drawer.querySelector('[data-cart-checkout]').hidden = !cart.items.length;
  }
  function closeCart() {if (drawer?.open) drawer.close();}
  function showCart(cart) {
    if (!drawer || typeof drawer.showModal !== 'function') {window.location.assign(route('cart'));return;}
    renderCart(cart);
    drawer.querySelector('[data-cart-status]').textContent = '';
    if (!drawer.open) {previousFocus = document.activeElement;drawer.showModal();document.body.style.overflow = 'hidden';}
  }
  if (drawer) {
    drawer.querySelector('[data-cart-close]')?.addEventListener('click', closeCart);
    drawer.addEventListener('close', () => {document.body.style.overflow = '';if (previousFocus?.isConnected) previousFocus.focus();});
    drawer.addEventListener('click', event => {if (event.target === drawer) {const r = drawer.getBoundingClientRect();if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeCart();}});
  }
  async function openCartFromLink(event) {
    event.preventDefault();
    try {showCart(await jsonRequest('cart.js'));}
    catch (_) {window.location.assign(route('cart'));}
  }
  function setImage(gallery, src, alt) {
    const img = gallery?.querySelector('.main-product-image');
    if (!img || !src) return;
    img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; img.alt = alt || 'Product image';
    gallery.querySelectorAll('[data-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.image === src)));
  }
  function init(scope = document) {
    scope.querySelectorAll('.video-frame video').forEach(video => {
      if (video.dataset.bound) return;
      video.dataset.bound = 'true';
      const fit = () => {if(video.videoWidth && video.videoHeight) video.closest('.video-frame').style.setProperty('--media-ratio',video.videoWidth/video.videoHeight);};
      video.addEventListener('loadedmetadata',fit);fit();
    });
    scope.querySelectorAll('[data-cart-open]').forEach(el => {if (el.dataset.bound) return;el.dataset.bound = 'true';el.addEventListener('click', openCartFromLink);});
    scope.querySelectorAll('[data-menu-toggle]').forEach(el => {
      if (el.dataset.bound) return;el.dataset.bound = 'true';
      const nav = document.getElementById(el.getAttribute('aria-controls'));
      if (!nav) return;
      const close = () => {nav.hidden = true;el.setAttribute('aria-expanded', 'false');};
      el.addEventListener('click', () => {nav.hidden = !nav.hidden;el.setAttribute('aria-expanded', String(!nav.hidden));});
      nav.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
      el.addEventListener('keydown', event => {if (event.key === 'Escape') {close();el.focus();}});
    });
    scope.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.bound) return;gallery.dataset.bound = 'true';
      gallery.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => setImage(gallery, button.dataset.image, button.dataset.imageAlt)));
    });
    scope.querySelectorAll('[data-product-form]').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const add = form.querySelector('[data-add]'), buy = form.querySelector('[data-buy-now]');
      const status = form.querySelector('[data-form-status]'), label = form.querySelector('[data-add-label]');
      const options = [...form.querySelectorAll('[name="quantity"]')];
      const total = form.querySelector('[data-bundle-total]');
      let busy = false;
      function selection() {return options.find(el => el.checked && !el.disabled);}
      function update() {
        if (!selection()) {const first = options.find(el => !el.disabled); if (first) first.checked = true;}
        const selected = selection();
        if (selected && total) total.textContent = selected.dataset.total;
        add.disabled = busy || !selected;
        if (buy) buy.disabled = add.disabled;
        label.textContent = busy ? 'Adding…' : selected ? (add.dataset.label || 'Add to Cart') : (add.dataset.soldoutLabel || 'Sold out');
        document.querySelectorAll('[data-sticky-offer]').forEach(el => {if(selected) el.textContent = `${selected.value} ${selected.value === '1' ? 'unit' : 'units'} · ${selected.dataset.total}`;});
      }
      options.forEach(el => el.addEventListener('change',update));
      async function submit(checkout) {
        if (busy || !selection() || !form.reportValidity()) return;
        const data = new FormData(form);
        busy = true; form.setAttribute('aria-busy','true'); update();
        options.forEach(el => {el.dataset.wasDisabled = String(el.disabled); el.disabled = true;});
        status.textContent = ''; status.classList.remove('is-error');
        try {
          await jsonRequest('cart/add.js', {method:'POST',body:data});
          if (checkout) {window.location.assign(route('checkout'));return;}
          status.textContent = 'Added to your cart.';
          try {showCart(await jsonRequest('cart.js'));}
          catch (_) {status.textContent = 'Added to your cart. Open your cart to continue.';}
        } catch(error) {status.textContent = error.message || 'Unable to add your product. Please try again.';status.classList.add('is-error');}
        finally {
          busy=false; form.setAttribute('aria-busy','false');
          options.forEach(el => {el.disabled=el.dataset.wasDisabled==='true';});update();
        }
      }
      form.addEventListener('submit',event=>{event.preventDefault();submit(false);});
      buy?.addEventListener('click',()=>submit(true));
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
